var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.$vuetify.theme.dark ? 'dark-mode' : 'light-mode'},[_c('custom-app-bar'),_c('v-main',{ref:"mainContainer",staticClass:"main-container",class:[_vm.$vuetify.theme.dark ? '' : 'grey lighten-3']},[_c('router-view'),(!_vm.user.isAdmin)?_c('app-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }